import axios from 'axios';

export default {
    methods: {
        async itemIndex(d, ok, err) {
            try {
                let r = await axios.get('items?page=' + d.page, {params: d});
                ok(r.data);
            } catch (e) {
                err(e);
            }
        },
        async itemUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('items/' + id, d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async itemStore(d, ok, err) {
            try {
                let r = await axios.post('items', d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async itemSearch(tipo, q, ok, err) {
            try {
                let r = await axios.post('items/search', {tipo_id: tipo, q: q});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemPanelSearch(empresa_id, q, ok, err) {
            try {
                let r = await axios.post('items/flete/search', {empresa_id: empresa_id, q: q});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemPrecio(params, ok, err) {
            try {
                let r = await axios.post('items/precio', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemTipos(ok, err) {
            try {
                let r = await axios.post('items/tipos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroUM(ok, err) {
            try {
                let r = await axios.post('items/micro-um');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroGrupo(d, ok, err) {
            try {
                let r = await axios.post('items/micro-grupo', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroProdEmp(params, ok, err) {
            try {
                let r = await axios.post('items/micro-prod-emp', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroSearch(params, ok, err) {
            try {
                let r = await axios.post('items/micro-search', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroSearchTodas(params, ok, err) {
            try {
                let r = await axios.post('items/micro-search-todas', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroSearchPag(params, ok, err) {
            try {
                let r = await axios.post('items/micro-search-pag', params);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemActivar(d, ok, err) {
            try {
                let r = await axios.post('items/activar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroProdSugerencias(d, ok, err) {
            try {
                let r = await axios.post('items/micro-prod-sugerencias', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroCtasSearch(d, ok, err) {
            try {
                let r = await axios.post('items/micro-ctas-search', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroCtas(d, ok, err) {
            try {
                let r = await axios.post('items/micro-ctas', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },

        async itemMicroLastId(d, ok, err) {
            try {
                let r = await axios.post('items/micro-last-id', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemMicroNextId(d, ok, err) {
            try {
                let r = await axios.post('items/micro-next-id', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/items.js